import React from 'react';

function TypeOfManagerField({ value, maxLength }) {
  if (!value) return <>-</>;

  if (maxLength && typeof value === 'string' && value.length > maxLength) {
    return <>{value.substr(0, maxLength)}...</>;
  }

  return (
    <>
      {value === 'ADMIN'
        ? 'Amministratore'
        : value === 'AGENCY'
        ? 'Agenzia'
        : value === 'ASSOCIATION'
        ? 'Associazione'
        : '-'}
    </>
  );
}

export default TypeOfManagerField;
